module.exports = __webpack_public_path__ + "static/img/Twitter.413a5e08.png";